import React, { useState } from 'react';
import {
  addSchemesToCampaign,
  getCampaigns,
  getUnassignedSchemes,
} from '../../redux/campaignActions';
import { Button } from '../../../../common/components';
import { connect, useSelector } from 'react-redux';
import { actions as productActions } from '../../../product/redux/productActions';

import { Modal } from 'react-bootstrap';
import AddSchemesToCampaignForm from './AddSchemesToCampaignForm';
import './style.scss';

const AddSchemesToCampaignModal = ({
  campaignId,
  productId,
  onClearSchemes,
  onGetUnassignedSchemes,
  onGetCampaign,
  onAddSchemesToCampaign,
}) => {
  const [show, setShow] = useState(false);
  const unassignedSchemes = useSelector(
    (state) => state.campaign?.unassignedSchemes?.[campaignId],
  );
  const save = (values) => {
    const schemes = values.schemes;
    const payload = {
      data: Object.keys(schemes)?.reduce((carry, schemeId) => {
        const scheme = schemes[schemeId];
        if (scheme.add) {
          carry.push({ id: schemeId });
        }

        return carry;
      }, []),
    };


    return Promise.resolve(onAddSchemesToCampaign(campaignId, payload)).then(
      () => {
        onGetCampaign(campaignId);
        handleClose();
      },
    );
  };

  const handleClose = () => {
    onClearSchemes();
    setShow(false);
  };

  const handleOpen = () => {
    return Promise.resolve(onGetUnassignedSchemes(campaignId, productId)).then(() => {
      setShow(true);
    });
  };

  return (
    <div>
      <Button
        handleClick={handleOpen}
        bsStyle="primary"
        className="pull-right pad-right"
        label="Add Schemes"
      />

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Add Schemes To Campaign</Modal.Title>
        </Modal.Header>
        {show && (
          <AddSchemesToCampaignForm
            onSave={save}
            unassignedSchemes={unassignedSchemes}
            onCancel={handleClose}
          />
        )}
      </Modal>
    </div>
  );
};

export default connect(
  null,
  {
    onClearSchemes: productActions.clearData,
    onGetCampaign: getCampaigns,
    onGetUnassignedSchemes: getUnassignedSchemes,
    onAddSchemesToCampaign: addSchemesToCampaign,
  },
)(AddSchemesToCampaignModal);

